/** @format */

import React from "react";
import cert from "src/assets/images/user/01.jpg";
import { Card, Col, Container, Row } from "react-bootstrap";

const CertificateCard = () => {
  return (
    <div id="content-page" className="content-inner">
      <Container className="mt-2">
        <Row className="justify-content-center">
          <Col sm="12">
            <Card className="border border-light rounded-lg shadow-md max-w-sm mt-2 text-end">
              {" "}
              <div className="border-b border-gray-200 p-3 text-center">
                <img src={cert} className="h-32 mx-auto" alt="Certificate" />
              </div>
              <div className="border-b border-gray-200 p-3 text-center">
                <h3 className="text-lg font-bold mb-1">
                  University Certificate
                </h3>
                <h6 className="text-xs mb-1">22 August 2024</h6>
                <h5 className="text-xs">University Tunku Abdul Rahman</h5>
              </div>
              <div className="p-3 text-center">
                <h5 className="text-md font-bold">
                  Verified by FirstCert Blockchain
                </h5>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CertificateCard;
